module.exports = __webpack_public_path__ + "static/media/jpg.63f035a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/jpg.png
// module id = 2561
// module chunks = 0